import React, { useEffect } from "react";
import { Modal, ModalBody } from "@vds/modals";
import { Title } from "@vds/typography";
import { css } from "@emotion/react";
import { CustomSLButton, FlexRow, Spacer, MediumText } from "../../components/core/utility";
import { Icon } from "@vds/icons";

export const StyledModal = css`
  max-height: 99vmin;
  padding: 1rem 1rem 1rem 1rem;
  padding-right: 2px;
  border-radius: 0.5rem !important;
  @media (max-width: 767px) {
    width: 560px !important;
    height: auto;
    min-height: 14.5rem;
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 2px;
  }

  & footer {
    padding: 0;
  }
`;

const ContactUpdateConfirmationModal = ({ showContactUpdateModal, setShowContactUpdateModal, handleContactUpdate }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setShowContactUpdateModal(false);
      }
    };
    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Modal
        role="dialog"
        ariaLabel="Confirmation Modal"
        hideCloseButton={false}
        opened={showContactUpdateModal}
        disableOutsideClick
        css={StyledModal}
        closeButton={
          <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
            <div>
              <Title size="medium">Confirmation</Title>
            </div>
            <div
              data-testId="close-icon"
              onClick={() => {
                setShowContactUpdateModal(false);
              }}
              style={{ marginRight: "1rem", marginTop: "0.3rem" }}
            >
              <Icon
                aria-label="close"
                alt="close-icon"
                role="img"
                name="close"
                size="medium"
                color="#000000"
                style={{ cursor: "pointer", outline: "none" }}
              />
            </div>
          </FlexRow>
        }
      >
        <ModalBody css={{ paddingLeft: "0", paddingRight: "0", marginTop: "0.5rem" }}>
          <div style={{ fontFamily: "Verizon-NHG-eDS", fontSize: "14px" }}>
            Are you sure you want to update the contact for current vehicle or you want to update the contact for all the vehicle
          </div>
          <Spacer top="1rem" />
          <FlexRow>
            <CustomSLButton
              aria-label="No"
              role="button"
              secondary
              onClick={() => {
                handleContactUpdate(false);
              }}
            >
              Update only for current
            </CustomSLButton>

            <CustomSLButton
              aria-label="Yes"
              role="button"
              css={{ padding: "0 10px 0 10px" }}
              primary
              onClick={() => {
                handleContactUpdate(true);
              }}
            >
              Update for all
            </CustomSLButton>
          </FlexRow>
        </ModalBody>
      </Modal>
    </>
  );
};
export default ContactUpdateConfirmationModal;
